/**
 * Status-Werte für E-Mail-, SMS- und WhatsApp-Queue (API/Backend).
 * Für Vergleiche und Filter verwenden, Anzeige über i18n (text/tr).
 */
export const COMMUNICATION_STATUS_PENDING = "pending";
export const COMMUNICATION_STATUS_SENDING = "sending";
export const COMMUNICATION_STATUS_SENT = "sent";
export const COMMUNICATION_STATUS_FAILED = "failed";

export const COMMUNICATION_STATUS_VALUES = [
  COMMUNICATION_STATUS_PENDING,
  COMMUNICATION_STATUS_SENDING,
  COMMUNICATION_STATUS_SENT,
  COMMUNICATION_STATUS_FAILED
] as const;
